import { baseApi } from './baseApi';

export const deliveryApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get delivery rates
    getDeliveryRates: builder.query({
      query: () => ({
        url: 'delivery/rates',
        method: 'GET',
      }),
      providesTags: ['DeliveryRates'],
    }),

    // Update delivery rates
    updateDeliveryRates: builder.mutation({
      query: (rates) => ({
        url: 'delivery/rates',
        method: 'PUT',
        body: rates,
      }),
      invalidatesTags: ['DeliveryRates'],
    }),

    // Calculate delivery cost for a specific distance
    calculateDeliveryCost: builder.query({
      query: (distance) => ({
        url: `delivery/calculate-cost?distance=${distance}`,
        method: 'GET',
      }),
    }),

    // Get delivery zones
    getDeliveryZones: builder.query({
      query: () => ({
        url: 'delivery/zones',
        method: 'GET',
      }),
      providesTags: ['DeliveryZones'],
    }),

    // Update delivery zones
    updateDeliveryZones: builder.mutation({
      query: (zones) => ({
        url: 'delivery/zones',
        method: 'PUT',
        body: zones,
      }),
      invalidatesTags: ['DeliveryZones'],
    }),

    // Get delivery pricing configuration
    getDeliveryPricing: builder.query({
      query: () => ({
        url: 'delivery-price',
        method: 'GET',
      }),
      providesTags: ['DeliveryPricing'],
    }),

    // Update delivery pricing configuration
    updateDeliveryPricing: builder.mutation({
      query: (pricing) => ({
        url: 'delivery-price',
        method: 'PUT',
        body: pricing,
      }),
      invalidatesTags: ['DeliveryPricing'],
    }),
  }),
});

export const {
  useGetDeliveryRatesQuery,
  useUpdateDeliveryRatesMutation,
  useCalculateDeliveryCostQuery,
  useGetDeliveryZonesQuery,
  useUpdateDeliveryZonesMutation,
  useGetDeliveryPricingQuery,
  useUpdateDeliveryPricingMutation,
} = deliveryApi;
